
import { defineComponent } from 'vue';

import NextFrame from '@/components/NextFrame.vue';

export default defineComponent({
  components: {
    NextFrame,
  },
});
